<template lang="html">
<div class="pgInner atvEdit">

    <div class="headBar">新建活动速递</div>

    <div class="pgbody" :style="'height:' + pageH + 'px;'">
         <el-scrollbar ref="scroller" style="height:100%;">

           <el-form ref="ruleForm" :model="params" :rules="rules" inline-message="true" :show-message="false">

               <div class="tabContent">

                 <div class="text-block clearfix">
                     <div class="bName">标题</div>
                     <div class="bContent">
                           <el-form-item prop="title">
                               <el-input size="medium" class="inpText" v-model="params.title" placeholder="请输入活动标题"></el-input>
                           </el-form-item>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">发布企业</div>
                     <div class="bContent">
                           <el-form-item prop="publishCompanyId">
                             <el-select
                                 class="inpText"
                                 v-model="params.publishCompanyId"
                                 filterable
                                 remote
                                 clearable
                                 reserve-keyword
                                 placeholder="输入企业名称"
                                 :remote-method="eprSeek"
                                 @change="eprSelect">
                                 <el-option
                                   v-for="item in selectArr"
                                   :key="item.id"
                                   :label="item.companyName"
                                   :value="item.id">
                                 </el-option>
                             </el-select>
                           </el-form-item>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">内容</div>
                     <div class="bContent">
                         <textEditor ref="textEditor" :inContent="params.content" />
                         <!-- <editor id="editor_id" height="500px" width="100%" :content="params.content"
                         @on-content-change="contentChange"
                         pluginsPath="/static/kindeditor/plugins/"
                         :loadStyleMode="false"></editor> -->
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">封面图</div>
                     <div class="bContent">
                           <img-upload :image="params.coverImage" @imgChange="imgChange" tips="（115*70推荐）" />
                     </div>
                 </div>

                 <div class="text-block radio-block clearfix">
                     <div class="bName">审核</div>
                     <div class="bContent">
                       <el-radio-group v-model="params.status">
                          <el-radio :label="3">通过</el-radio>
                          <el-radio :label="4">不通过</el-radio>
                       </el-radio-group>
                     </div>
                 </div>

               </div>

            </el-form>

         </el-scrollbar>
    </div>

    <div class="pagefoot">

      <div v-if="pgState" class="loading">
           <span v-if="pgState == 3">初始化中...</span>
           <span v-if="pgState == 4">数据保存中...</span>
           <i class="el-icon-loading"></i>
      </div>
      <div v-else>
           <el-button @click="directSave" type="primary" size="small">保存</el-button>
           <el-button @click="goReturn" plain size="small">取消</el-button>
      </div>

    </div>

</div>
</template>

<script>
import Editor from "@/components/KindEditor/KindEditor";
import { msgCreate, msgPredat } from "@/api/message/message";
import { dicSeek } from "@/api/pgMent/dictMent";
import { getEnterpriseList } from "@/api/attes/attestation";
export default {
  components: {
    Editor
  },
  computed: {
    pgState: function () {
      var state = 0;
      if (this.params.id && !this.readyKey) {
        state = 1;
      }

      if (this.uploadIng) {
        state = 2;
      }

      return state;
    }
  },
  data() {
    return {

      pageH: '',
      selectArr: [],
      selectMap: {},
      uploadIng: false,
      readyKey: false,

      params: {
        id: '',
        businessNewsType: '',
        businessNewsTypeId: '',

        publishCompany: '', // 企业
        publishCompanyId: '',

        title: '',
        content: '',
        coverImage: '',
        status: 3,
      },

      preCode: '',
      pgName: '',

      rules: {
        title: [{
          required: true,
          trigger: 'blur'
        }],
        content: [{
          required: true,
          trigger: 'blur'
        }],
        publishCompanyId: [{
          required: true,
          trigger: 'blur'
        }]
      }

    }
  },

  methods: {

    goReturn: function () {
      this.$router.go(-1);
    },

    pageFix: function () {
      this.pageH = document.documentElement.clientHeight - 205;
    },

    contentChange: function (e) {    // 富文本内容
      this.params.content = e;
    },

    eprSeek: function (e) {   // 公司检索
      var vues = this;
      var key = e.replace(/\s+/g, '');
      if (key) {
        getEnterpriseList({
          status: '',
          keyword: key,
          sort: 2,
          no: 1,
          size: 12
        }).then(res => {
          vues.selectArr = res.enterpriseList;
          vues.selectArr.forEach(item => {
            vues.selectMap[item.id] = item;
          })
        })
      }
    },

    eprSelect: function (e) {
      this.params.publishCompany = this.selectMap[e].companyName;
      this.params.publishCompanyId = e;
    },

    goCreate: function () {  // 创建
      var vues = this;
      this.uploadIng = true;
      msgCreate({ businessNews: this.params }).then(res => {
        vues.$router.push('atv_message');
      }).catch(err => { })
    },

    tmSave: function () {
      var vues = this;
      this.waitSave = setInterval(function () {
        var nowCode = JSON.stringify(vues.params);
        if (nowCode !== vues.preCode) {
          vues.goCreate();
          vues.preCode = nowCode;
        }
      }, 60000)
    },

    directSave: function () {
      var vues = this;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          vues.params.content = this.$refs.textEditor.editorContent;
          if (!vues.params.content) {
            vues.$message.error('内容不能为空!');
          } else if (!vues.params.coverImage) {
            vues.$message.error('请上传封面图!');
          } else {
            vues.goCreate();
          }
        }
      })
    },

    imgChange: function (e) {
      this.params.coverImage = e;
    },

    prevSet: function () {

      var vues = this;
      var querys = this.$route.query;

      // 底部定位
      this.pageFix();

      if (querys && querys.id) {
        this.params.id = querys.id;
        msgPredat({ id: querys.id }).then(res => {
          vues.params = res.businessNews;
          vues.eprSeek(vues.params.publishCompany);
          vues.readyKey = true;
        })
      } else {
        this.preCode = JSON.stringify(this.params);
        // this.tmSave();
      }

    },
  },
  created: function () {
    var vues = this;

    $(window).resize(function () {
      vues.pageFix();
      vues.$refs.scroller.$data.sizeHeight = this.pageH;
    })

    // 获取商讯 type
    dicSeek({ code: 'shangx' }).then(res => {
      var unFormate = res.dataDictionarys;
      unFormate.forEach(item => {
        if (item.sort == 1) {
          vues.params.businessNewsType = item.name;
          vues.params.businessNewsTypeId = item.id;
          return false;
        }
      });

      this.prevSet();
    })

  },

  beforeDestroy: function () {
    clearInterval(this.waitSave);
  }


}
</script>

<style lang="scss" scoped>
.pgInner {
  background: #f5f5f5;
}

.headBar {
  height: 55px;
  line-height: 55px;
  font-size: 16px;
  padding-left: 20px;
  background: white;
}

.pgbody {
  margin: 20px;
}

.tabNavs {
  height: 50px;
  padding-left: 15px;
  background: white;
  position: relative;
  .tabItem {
    float: left;
    height: 50px;
    line-height: 50px;
    font-size: 15px;
    margin-right: 45px;
    cursor: pointer;
  }
  .tabItem.act {
    color: rgb(86, 119, 252);
  }
  .moveLine {
    height: 2px;
    background: rgb(86, 119, 252);
    position: absolute;
    bottom: 0px;

    transition-property: all;
    transition-duration: 0.2s;
  }
}

.tabContent {
  padding: 20px;
  background: white;
}

.pagefoot {
  height: 60px;
  line-height: 60px;
  background: white;
  padding-left: 20px;
  position: relative;
  z-index: 2;
  .btn {
    height: 32px;
    padding: 0 12px;
    margin-right: 12px;
    display: inline-block;
    font-size: 14px;
    cursor: pointer;
  }
  .type1 {
    line-height: 32px;
    background: rgb(86, 119, 252);
    color: white;
  }
  .type2 {
    box-sizing: border-box;
    border: 1px solid #aeaeae;
    line-height: 30px;
  }

  .loading {
    font-size: 14px;
    padding-left: 24px;
    color: #aeaeae;
    i {
      font-size: 18px;
      vertical-align: middle;
    }
  }
}

.text-block {
  font-size: 14px;
  .bName {
    width: 60px;
    padding-top: 8px;
    float: left;
  }
  .bContent {
    margin-left: 70px;
    position: relative;
    margin-bottom: 20px;

    .inpText {
      width: 420px;
    }
  }
}

.radio-block .el-radio-group {
  margin-top: 12px;
}
</style>

<style lang="css">
.atvEdit .el-input__inner {
  border-radius: 0px;
}
</style>



// WEBPACK FOOTER //
// atvEdit.vue?22777b72